function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import { productActivityListApi } from '@/api/product';
import toolCom from '../mobileConfigRight/index.js';
import rightBtn from '../rightBtn/index.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'c_home_goods_list',
  componentsName: 'home_goods_list',
  cname: '商品列表',
  props: {
    activeIndex: {
      type: null
    },
    num: {
      type: null
    },
    index: {
      type: null
    }
  },
  components: _objectSpread(_objectSpread({}, toolCom), {}, {
    rightBtn: rightBtn
  }),
  computed: _objectSpread(_objectSpread({}, mapGetters(['merPlatProductClassify', 'productBrand'])), {}, {
    //商品排序
    goodsSort: function goodsSort() {
      return this.configObj.goodsSort.tabVal;
    },
    //选择方式
    tabConfig: function tabConfig() {
      return this.configObj.tabConfig.tabVal;
    }
  }),
  data: function data() {
    return {
      configObj: {},
      rCom: [{
        components: toolCom.c_checked_tab,
        configNme: 'setUp'
      }],
      automatic: [{
        components: toolCom.c_title,
        configNme: 'itemStyle'
      }, {
        components: toolCom.c_txt_tab,
        configNme: 'itemStyle'
      }, {
        components: toolCom.c_title,
        configNme: 'typeConfig'
      }, {
        components: toolCom.c_checkbox_group,
        configNme: 'typeConfig'
      }, {
        components: toolCom.c_title,
        configNme: 'tabConfig'
      }, {
        components: toolCom.c_tab_radio,
        configNme: 'tabConfig'
      }, {
        components: toolCom.c_goods,
        configNme: 'goodsList'
      }, {
        components: toolCom.c_select,
        configNme: 'activeValueBrand'
      }, {
        components: toolCom.c_cascader,
        configNme: 'selectConfig'
      }, {
        components: toolCom.c_merchantName,
        configNme: 'activeValueMer'
      }, {
        components: toolCom.c_input_number,
        configNme: 'numConfig'
      }, {
        components: toolCom.c_txt_tab,
        configNme: 'goodsSort'
      }, {
        components: toolCom.c_txt_tab,
        configNme: 'sortCollation'
      }],
      setUp: 0,
      type: 0,
      lockStatus: false
    };
  },
  watch: {
    num: function num(nVal) {
      var value = JSON.parse(JSON.stringify(this.$store.state.mobildConfig.defaultArray[nVal]));
      this.configObj = value;
    },
    configObj: {
      handler: function handler(nVal, oVal) {
        this.$store.commit('mobildConfig/UPDATEARR', {
          num: this.num,
          val: nVal
        });
      },
      deep: true
    },
    'configObj.setUp.tabVal': {
      handler: function handler(nVal, oVal) {
        this.setUp = nVal;
        var arr = [this.rCom[0]];
        if (nVal == 0) {
          this.rCom = arr.concat(this.automatic);
        } else {
          var tempArr = [{
            components: toolCom.c_title,
            configNme: 'bgColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'bgColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'titleColor'
          }, {
            components: toolCom.c_radio,
            configNme: 'themeStyleConfig'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'priceColor'
          }, {
            components: toolCom.c_bg_color,
            configNme: 'soldColor'
          }, {
            components: toolCom.c_title,
            configNme: 'upConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'upConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'downConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'lrConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'contentConfig'
          }, {
            components: toolCom.c_slider,
            configNme: 'mbConfig'
          }, {
            components: toolCom.c_title,
            configNme: 'bgStyle'
          }, {
            components: toolCom.c_slider,
            configNme: 'bgStyle'
          }, {
            components: toolCom.c_slider,
            configNme: 'contentStyle'
          }];
          this.rCom = arr.concat(tempArr);
        }
      },
      deep: true
    },
    //选择方式选择，0指定商品，1指定分类，2指定品牌，3指定商户
    'configObj.tabConfig.tabVal': {
      handler: function handler(nVal, oVal) {
        this.type = nVal;
        switch (this.type) {
          case 0:
            this.$set(this.configObj.selectConfig, 'list', this.merPlatProductClassify);
            this.$set(this.configObj.numConfig, 'isShow', 0); //是否显示inputnumber框
            this.$set(this.configObj.goodsList, 'isShow', 1); //选择商品
            this.$set(this.configObj.activeValueBrand, 'isShow', 0); //选择品牌
            this.$set(this.configObj.selectConfig, 'isShow', 0); //选择分类
            this.$set(this.configObj.activeValueMer, 'isShow', 0); //选择商户
            this.$set(this.configObj.goodsSort, 'isShow', 0); //商品排序
            this.$set(this.configObj.sortCollation, 'isShow', 0); //排序规则
            break;
          case 1:
            this.$set(this.configObj.selectConfig, 'list', this.merPlatProductClassify);
            this.$set(this.configObj.numConfig, 'isShow', 1);
            this.$set(this.configObj.goodsList, 'isShow', 0); //选择商品
            this.$set(this.configObj.activeValueBrand, 'isShow', 0); //选择品牌
            this.$set(this.configObj.selectConfig, 'isShow', 1); //选择分类
            this.$set(this.configObj.activeValueMer, 'isShow', 0); //选择商户
            this.$set(this.configObj.goodsSort, 'isShow', 1); //商品排序
            this.$set(this.configObj.goodsSort, 'tabVal', 0); //排序规则
            break;
          case 2:
            this.$set(this.configObj.activeValueBrand, 'list', this.productBrand);
            this.$set(this.configObj.numConfig, 'isShow', 1);
            this.$set(this.configObj.goodsList, 'isShow', 0); //选择商品
            this.$set(this.configObj.activeValueBrand, 'isShow', 1); //选择品牌
            this.$set(this.configObj.selectConfig, 'isShow', 0); //选择分类
            this.$set(this.configObj.activeValueMer, 'isShow', 0); //选择商户
            this.$set(this.configObj.goodsSort, 'isShow', 1); //商品排序
            this.$set(this.configObj.goodsSort, 'tabVal', 0); //排序规则
            break;
          case 3:
            this.$set(this.configObj.numConfig, 'isShow', 1);
            this.$set(this.configObj.goodsList, 'isShow', 0); //选择商品
            this.$set(this.configObj.activeValueBrand, 'isShow', 0); //选择品牌
            this.$set(this.configObj.selectConfig, 'isShow', 0); //选择分类
            this.$set(this.configObj.activeValueMer, 'isShow', 1); //选择商户
            this.$set(this.configObj.goodsSort, 'isShow', 1); //商品排序
            this.$set(this.configObj.goodsSort, 'tabVal', 0); //排序规则
            break;
        }
      },
      deep: true
    },
    'configObj.goodsSort.tabVal': {
      handler: function handler(nVal, oVal) {
        switch (nVal) {
          case 0:
            this.$set(this.configObj.sortCollation, 'isShow', 0); //排序规则
            break;
          case 1:
            this.$set(this.configObj.sortCollation, 'isShow', 1); //排序规则
            break;
          case 2:
            this.$set(this.configObj.sortCollation, 'isShow', 1); // 排序规则
            break;
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var value = JSON.parse(JSON.stringify(_this.$store.state.mobildConfig.defaultArray[_this.num]));
      _this.configObj = value;
      if (!localStorage.getItem('merPlatProductClassify')) _this.$store.dispatch('product/getAdminProductClassify');
      if (!localStorage.getItem('productBrand')) _this.$store.dispatch('product/getMerProductBrand');
      _this.$nextTick(function () {
        if (_this.configObj.tabConfig.tabVal === 0 || _this.configObj.goodsSort.tabVal === 0) {
          _this.$set(_this.configObj.sortCollation, 'isShow', 0); //排序规则
        } else {
          _this.$set(_this.configObj.sortCollation, 'isShow', 1); //排序规则
        }
        _this.$set(_this.configObj.selectConfig, 'list', _this.merPlatProductClassify);
        _this.$set(_this.configObj.selectConfig, 'list', _this.merProductClassify);
      });
    });
  },
  methods: {
    getConfig: function getConfig(data) {
      //选择tab获取商品列表.0指定商品
      if (data.name && data.name === 'goods') this.configObj.goodsList.list = data.values;
      //选择tab获取商品列表,1指定品牌，2指定分类，3指定商户
      this.getProList(data);
    },
    //选择tab获取商品列表
    getProList: function getProList(data) {
      var _this2 = this;
      if (data.name && (data.name === 'merchantName' || data.name === 'select' || data.name === 'cascader' || data.name === 'radio' || data.name === 'number')) {
        var activeValue = '';
        var priceOrder = '';
        var salesOrder = '';
        switch (this.tabConfig) {
          case 0:
            break;
          case 1:
            activeValue = this.configObj.selectConfig.activeValue.join(',');
            break;
          case 2:
            activeValue = this.configObj.activeValueBrand.activeValue.join(',');
            break;
          case 3:
            activeValue = this.configObj.activeValueMer.activeValue.join(',');
            break;
        }
        if (this.goodsSort === 0) {
          priceOrder = '';
          salesOrder = '';
        } else if (this.goodsSort === 1) {
          if (this.configObj.sortCollation.tabVal === 0) {
            priceOrder = '';
            salesOrder = 'asc';
          } else {
            priceOrder = '';
            salesOrder = 'desc';
          }
        } else {
          if (this.configObj.sortCollation.tabVal === 0) {
            priceOrder = 'asc';
            salesOrder = '';
          } else {
            priceOrder = 'desc';
            salesOrder = '';
          }
        }
        productActivityListApi({
          categoryId: this.tabConfig === 1 ? activeValue : null,
          page: 1,
          limit: this.configObj.numConfig.val,
          type: '1',
          brandId: this.tabConfig === 2 ? activeValue : null,
          merIds: this.tabConfig === 3 ? activeValue : null,
          priceOrder: priceOrder,
          salesOrder: salesOrder
        }).then(function (res) {
          //选择tab获取商品列表,1指定分类，2指定品牌，3指定商户
          switch (_this2.configObj.tabConfig.tabVal) {
            case 1:
              _this2.configObj.selectConfig.goodsList = res.list;
              break;
            case 2:
              _this2.configObj.activeValueBrand.goodsList = res.list;
              break;
            case 3:
              _this2.configObj.activeValueMer.goodsList = res.list;
              break;
          }
        });
      }
    }
  }
};